// @flow
import axios from 'axios';

// Everything a logout clears on this device, apart from telling the API: the token and clinic the requests
// carry (the next person's would carry them), the lists persisted in localStorage, the Cache Storage caches
// (thumbnails, profile photos) and the stored state. logout() runs it once the API signed the session out;
// a start that can't reach the API runs it for "Sair e entrar de novo" and its logged-out fallback.
// Resolves when the stored state is gone.
export const clearLocalLogin = (): Promise<any> => {
  delete axios.defaults.headers.clinicId;
  delete axios.defaults.headers['access-token'];
  Object.keys(localStorage).forEach((key) => {
    if (key && key.startsWith('doutore-persist-data-v2')) localStorage.removeItem(key);
  });
  // A cache that can't be listed or deleted (storage errors, private windows) is left: no unhandled rejection
  if (window.caches) {
    Promise.resolve().then(() => window.caches.keys()).then((names) => {
      names.forEach((name) => { Promise.resolve().then(() => window.caches.delete(name)).catch(() => {}); });
    }).catch(() => {});
  }
  return window.idb.reset();
};

export default clearLocalLogin;
